import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app'
import './styles/globals.less'
import './i18n/config'
import * as Sentry from '@sentry/react'
import {
  CometChatUIKit,
  UIKitSettingsBuilder,
} from '@cometchat/chat-uikit-react'

Sentry.init({
  dsn: 'https://cdf2002e217f0d296f5ccb3cf2dd61db@o4507145245687808.ingest.us.sentry.io/4507325809491968',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/api\.regenenergy\.io\/api/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

const appId = import.meta.env.VITE_COMET_APP_ID
const region = import.meta.env.VITE_COMET_REGION

if (appId && region) {
  const settings = new UIKitSettingsBuilder()
    .setAppId(appId)
    .setRegion(region)
    .subscribePresenceForAllUsers()
    .build()
  CometChatUIKit.init(settings)?.then(() => {
    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
      <App />
    )
  })
} else {
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <App />
  )
}

